'use strict';

function parse(reader) {
    reader.readUInt8('data.params', value => {
        return {
            0: "gsm7bit",
            4: "gsm8bit",
            8: "ucs2",
        }[value];
    });
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/message-encoding-parser.js